/* 

Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.

*/

import { useState, useEffect, useCallback } from 'react';
import axiosCall from '../../services/axios';
import useAbortController from './useAbortController';
import { useAuthContext } from '../../contexts/AuthContext';

const useGetUserDutyCodes = (uid: string, companyCode: string) => {
  const [userDutyCodes, setUserDutyCodes] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const { token } = useAuthContext();

  const { reset } = useAbortController();

  const getUserDutyCodes = useCallback(async () => {
    if (!uid || !token || !companyCode) {
      return;
    }
    setLoading(true);
    const url = process.env.REACT_APP_MOL_USER + uid + '/duty/' + companyCode + '/list';

    const controller = reset();
    const config = { signal: controller.signal };

    const headers = {
      'Session-Token': token,
      'Content-Type': 'application/json',
    };

    try {
      let response = await axiosCall({ url: url, method: 'get' }, config, headers);
      setErrorMessage('');
      setUserDutyCodes(response);
      setLoading(false);
    } catch (error) {
      setErrorMessage('Error Loading Users duty codes:' + uid);
      setLoading(false);
      console.error(error.message);
    }
  }, [uid, companyCode, token]);

  useEffect(() => {
    getUserDutyCodes();
  }, [getUserDutyCodes]);

  return {
    userDutyCodes: userDutyCodes,
    userDutyCodesErrors: errorMessage,
    loadingUserDutyCodes: loading,
  };
};

export default useGetUserDutyCodes;
